import React from "react";

import { FormSubSections } from "../../entities/formTemplateDataType";
import EditSubsectionButtonComponent from "../subComponent/EditSubsectionButtonComponent";
import DeleteSubsectionButtonComponent from "../subComponent/DeleteSubsectionButtonComponent";
import SubsectionTextDisplayComponent from "../subComponent/SubsectionTextDisplayComponent";
import { ENGLISH_SLOGAN, GRAPHIC, NO_GRAPHIC, PASSENGER_PLATE, renderPlateImage } from "../../utilities/custom/PlpUtils";
import { findSectionElementByFieldName } from "../../utilities/ElementUtils";

type DuplicateSubSectionProps = {
    isEng: boolean;
    activeSubSection: FormSubSections;
    subsecIndex: number;
    callback;
    callbackValidate: (errors: any) => void
};

const DuplicateSubSectionSummary = ({isEng, activeSubSection, subsecIndex, callback, callbackValidate} : DuplicateSubSectionProps) => {
    const generateElements = () => {
        let htmlString = [];
        let canvasHtml = [];
        let buttonsHtml = [];
        let displayPlateImage = false;
        activeSubSection.ListOfFormSectionElements.forEach((element) => {
            switch (element.Datatype) {
                case 'SubsectionTextDisplay':
                    htmlString.push(
                        <SubsectionTextDisplayComponent 
                            isEng={isEng} 
                            field={element}
                        />
                    );
                    break;
                case 'EditSubsectionButton': 
                    buttonsHtml.push(
                        <EditSubsectionButtonComponent 
                            isEng={isEng} 
                            field={element}
                            callbackValidate={callbackValidate}
                            callback={callback}
                        />
                    );
                    break;
                case 'DeleteSubsectionButton':
                    buttonsHtml.push(
                        <DeleteSubsectionButtonComponent 
                            isEng={isEng} 
                            field={element} 
                            callback={callback}
                        />
                    );
                    break;
                case 'CheckPlateAndRenderImage':
                    canvasHtml.push(
                        <div id={`plate-image-summary-` + subsecIndex} style={{marginBottom: '16px', marginRight: '76px'}}></div>
                    );
                    displayPlateImage = true;
                    break;
            }
        });
        if (displayPlateImage) {
            // type of plate
            const plateType = findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'plateType')?.Value || PASSENGER_PLATE;
            // slogan language
            const sloganLanguage = findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'sloganLanguage').Value || ENGLISH_SLOGAN;
            // graphic selection
            const wantGraphic = findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'wantGraphic')?.Value || NO_GRAPHIC;
            let graphicType = NO_GRAPHIC;
            if (wantGraphic === GRAPHIC) {
                graphicType = findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'graphicPlateSearch')?.Value || findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'graphicType')?.Value;
            }
            // plate characters
            const plateNumber = findSectionElementByFieldName(activeSubSection.ListOfFormSectionElements, 'plateCharacters')?.Value || "";

            renderPlateImage(plateType, sloganLanguage, graphicType, plateNumber, subsecIndex);
        }
        return (<>
            <div style={{ display: 'flex', flexWrap: "wrap" }}>
                {canvasHtml}
                <div>{htmlString}</div>
            </div>
            {buttonsHtml}
        </>);
    };

    return(
        <div key={'sub_' + subsecIndex}>
            {generateElements()}
        </div>
    );

}
export default DuplicateSubSectionSummary;